import Head from "next/head"
import { fontsPath } from 'utils/path'
import * as env from "lib/env"


const AppHead = () => {
    return (
        <Head>
            <meta charSet="utf-8" />
            <link rel="shortcut icon" href="/favicon.ico" />
            <meta charSet="utf-8" />
            <meta
                name="viewport"
                content="width=device-width,initial-scale=1,minimum-scale=1"
            />
            <meta name="version" content={env.GITHUB_REF_NAME} />
            <link rel="shortcut icon" href="/favicon.ico" />
            <title>Onboarding Hub</title>
            <style>
                {`
                  @font-face {
                    font-family: 'Public Sans';
                    src: url(${fontsPath}/PublicSans-Regular.woff) format('woff'), url(${fontsPath}/PublicSans-Regular.woff2) format('woff2');
                    font-weight: 400;
                    font-style: normal;
                  }
                  @font-face {
                    font-family: 'Public Sans';
                    src: url(${fontsPath}/PublicSans-Medium.woff) format('woff'), url(${fontsPath}/PublicSans-Medium.woff2) format('woff2');
                    font-weight: 500;
                    font-style: normal;
                  }
                  
                  @font-face {
                    font-family: 'Public Sans';
                    src: url(${fontsPath}/PublicSans-SemiBold.woff) format('woff'), url(${fontsPath}/PublicSans-SemiBold.woff2) format('woff2');
                    font-weight: 600;
                    font-style: italic;
                  }
                  
                  @font-face {
                    font-family: 'Public Sans';
                    src: url(${fontsPath}/PublicSans-Bold.woff) format('woff'), url(${fontsPath}/PublicSans-Bold.woff2) format('woff2');
                    font-weight: 700;
                    font-style: normal;
                  }
                  
                  @font-face {
                    font-family: 'Public Sans';
                    src: url(${fontsPath}/PublicSans-ExtraBold.woff) format('woff'), url(${fontsPath}/PublicSans-ExtraBold.woff2) format('woff2');
                    font-weight: 800;
                    font-style: normal;
                  }
                `}
            </style>
        </Head>
    )
}

export default AppHead
